export default __webpack_public_path__ + "static/media/business.095d75d9.svg";